import _ from 'lodash'
import { ASharedModal, SharedModalTitle } from 'views/components/SharedModal'
import { AddFields, FarmerLoadCommonContent } from './ModalCommonContent'
import { useFormik } from 'formik'
import { useAFormHandler } from 'analytics/hooks'
import { apiClient } from 'modules/utils/httpClient'
import { refetchFunc } from 'modules/domain/common/hooks'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { endpoints } from 'modules/endpoints'
import { FarmerLoadWorkTypes } from 'modules/domain/deal/types'

type Props = {
  onClose: () => void
  refetch: refetchFunc
  dealId: string
}

export const AddFarmerLoadModal: FC<Props> = ({ onClose, refetch, dealId }) => {
  const { t } = useTranslation('deal')

  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik<AddFields>({
    initialValues: {
      regional: '',
      work_type: [FarmerLoadWorkTypes.sample, FarmerLoadWorkTypes.loading, FarmerLoadWorkTypes.documents],
      load_date: null,
      quantity: null,
      record_type: 'not_export',
    },

    onSubmit: formHandler(
      () => {
        const restData = _.omit(formik.values, 'work_type')
        const data = formik.values.work_type.map((work_type) => ({
          work_type,
          ...restData,
        }))
        return Promise.all(data.map((workData) => apiClient.post(endpoints.dealFarmerLoading(dealId), workData)))
      },
      {
        onSuccess: async () => {
          await refetch(true)
          onClose()
        },
        onError: (error) => {
          const { errors } = error
          formik.setErrors(errors)
        },
      },
    ),
  })

  return (
    <ASharedModal id="farmerLoading" onClose={onClose}>
      <SharedModalTitle>{t('accordion.loading.add_farmer_load')}</SharedModalTitle>
      <FarmerLoadCommonContent formik={formik} progress={formProgress} onClose={onClose} />
    </ASharedModal>
  )
}
